import SvgIconStyle from "src/components/SvgIconStyle";
import { PATH_DASHBOARD } from "src/utils/paths";

// ----------------------------------------------------------------------

const getIcon = (name: string) => (
	<SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

export const ICONS = {
	user: getIcon("ic_user"),
	dashboard: getIcon("ic_dashboard"),
	home: getIcon("ic_home"),
	kanban: getIcon("ic_kanban"),
	settings: getIcon("ic_settings"),
	transactions: getIcon("ic_transactions"),
	positions: getIcon("ic_positions"),
	transfers: getIcon("ic_transfers")
};

export const productsConfig = [
	{
		id: "TRANSACTIONS",
		title: "account_popover.app_transactions",
		path: PATH_DASHBOARD.app.transactions,
		icon: ICONS.transactions
	},
	{
		id: "ACTIVE_POSITIONS",
		title: "account_popover.app_positions",
		path: PATH_DASHBOARD.app.positions,
		icon: ICONS.positions
	},
	{
		id: "ASSETS_TRANSFER",
		title: "account_popover.app_transfers",
		path: PATH_DASHBOARD.app.transfers,
		icon: ICONS.transfers
	}
];

export const generalConfig = [
	{
		title: "account_popover.overview",
		path: PATH_DASHBOARD.app.overview,
		icon: ICONS.home
	},
	{
		title: "account_popover.app_settings",
		path: PATH_DASHBOARD.app.settings,
		icon: ICONS.settings
	}
];

export const defaultManagment = [
	{
		title: "Admin",
		path: PATH_DASHBOARD.admin,
		icon: ICONS.kanban,
		isTranslate: true
	}
];

const navConfig = [
	// GENERAL
	// ----------------------------------------------------------------------
	{
		subheader: "General",
		items: generalConfig
	}
];

export default navConfig;
